import Menu from 'antd/lib/menu'
import 'antd/lib/menu/style/index.less'

export default Menu
